import {Alert, styled} from '@mui/material';
import {useNetworkState} from 'react-use';

import {createPortalComponent} from 'utils/portalUtils';

const SAlertWrapper = styled('div')(({theme}) => ({
  position: 'fixed',
  top: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'max-content',
  maxWidth: '100vw',
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  zIndex: theme.zIndex.tooltip + 1,
}));

const SAlert = styled(Alert)(() => ({
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}));

const SRootPortal = createPortalComponent(null, SAlertWrapper);

export const OfflineBanner = () => {
  const {online} = useNetworkState();
  return online ? null : (
    <SRootPortal className='mui-fixed'>
      <SAlert variant='filled' severity='warning'>
        You are currently offline. Please check your internet connection.
      </SAlert>
    </SRootPortal>
  );
};
